module.exports = __webpack_public_path__ + "img/propStatus1.4f03c1f8.png";